import React from 'react';
import './App.css'; // ensure this is included

const Documentation: React.FC = () => {
    return (
        <div className="documentation-container">
            <div className="documentation-content">

                <h1>Equature Verbatim - Zoom App Documentation</h1>
                <p>Complete guide to installing, configuring, and using the Equature Verbatim Zoom App.</p>

                <h2>1. Introduction</h2>
                <p>
                    Equature Verbatim is a Zoom app that retrieves meeting and call media for analysis within the Equature platform. It can be accessed during Zoom meetings or from the Zoom desktop workspace.
                </p>

                <h2>2. Key Features</h2>
                <ul>
                    <li>Retrieves meeting audio/video from Zoom</li>
                    <li>Retrieves call and voicemail media from Zoom phone</li>
                    <li>Allow users to download meeting and call audio and video recordings</li>
                    <li>Works inside and outside Zoom meetings</li>
                    <li>Simple Zoom-integrated interface</li>
                    <li>Supports host and participant usage</li>
                </ul>

                <h2>3. Installing Equature Verbatim</h2>
                <p>
                    Users install the app from the Zoom App Marketplace and must authorize
                    the requested permissions during installation.
                </p>

                <h2>4. Using the App In a Meeting</h2>
                <p>
                    When you open the Verbatim panel during a Zoom meeting as the host:
                    <ul>
                        <li>
                            A new Verbatim participant will automatically join the meeting.
                        </li>
                        <li>Once recording permissions are granted to Verbatim, no further actions are required.</li>
                        <li>Verbatim will automatically capture the meeting media for further processing.</li>
                    </ul>
                </p>

                <h2>5. Using the App Outside a Meeting</h2>
                <p>
                    Users can open Verbatim from the Zoom desktop workspace to:
                </p>
                <ul>
                    <li>View or download media from past meetings and calls.</li>
                    <li>Automatically retrieve call and voicemail recordings when they become available.</li>
                </ul>
                <p>
                    Equature Verbatim is notified when a call or voicemail recording becomes available for download.
                    Once notified, Verbatim automatically downloads the media for further processing.
                    All necessary permissions are granted during installation, so no additional setup is required.
                </p>

                <h2>6. Uninstalling</h2>
                <p>
                    The app can be removed from the Zoom App Marketplace under Manage → Installed Apps.
                </p>

                <h2>7. Troubleshooting</h2>
                <p>
                    If you see a configuration message, contact Equature Support to finalize setup.
                </p>

                <h2>8. Support</h2>
                <p>
                    For help with installation, setup, or issues, contact Equature Support.
                </p>
            </div>
        </div>
    );
};

export default Documentation;
